import _DiaryShortsAnimatePresenceDiv from '../diary-shorts/_DiaryShortsAnimatePresenceDiv';
import _DiaryShortsComment from '../diary-shorts/_DiaryShortsComment';
import _DiaryShortsCommentBottomSheet from '../diary-shorts/_DiaryShortsCommentBottomSheet';
import _DiaryShortsContent from '../diary-shorts/_DiaryShortsContent';
import _DiaryShortsFooter from '../diary-shorts/_DiaryShortsFooter';
import _DiaryShortsHeader from '../diary-shorts/_DiaryShortsHeader';
import _DiaryShortsHelper from '../diary-shorts/_DiaryShortsHelper';
import _DiaryShortsHorizontalPhotoWrapper from '../diary-shorts/_DiaryShortsHorizontalPhotoWrapper';
import _DiaryShortsIngredients from '../diary-shorts/_DiaryShortsIngredients';
import _DiaryShortsLike from '../diary-shorts/_DiaryShortsLike';
import _DiaryShortsPhoto from '../diary-shorts/_DiaryShortsPhoto';
import _DiaryShortsPhotoIndicator from '../diary-shorts/_DiaryShortsPhotoIndicator';
import _DiaryShortsReferencedRecipe from '../diary-shorts/_DiaryShortsReferencedRecipe';
import _DiaryShortsRoot from '../diary-shorts/_DiaryShortsRoot';
import _DiaryShortsVerticalPhotoWrapper from '../diary-shorts/_DiaryShortsVerticalPhotoWrapper';

const DiaryShorts = () => null;

DiaryShorts.Root = _DiaryShortsRoot;
DiaryShorts.Header = _DiaryShortsHeader;
DiaryShorts.VerticalPhotoWrapper = _DiaryShortsVerticalPhotoWrapper;
DiaryShorts.HorizontalPhotoWrapper = _DiaryShortsHorizontalPhotoWrapper;
DiaryShorts.Photo = _DiaryShortsPhoto;
DiaryShorts.PhotoIndicator = _DiaryShortsPhotoIndicator;
DiaryShorts.Helper = _DiaryShortsHelper;
DiaryShorts.Footer = _DiaryShortsFooter;
DiaryShorts.Ingredients = _DiaryShortsIngredients;
DiaryShorts.Content = _DiaryShortsContent;
DiaryShorts.AnimatePresenceDiv = _DiaryShortsAnimatePresenceDiv;
DiaryShorts.ReferencedRecipe = _DiaryShortsReferencedRecipe;
DiaryShorts.Comment = _DiaryShortsComment;
DiaryShorts.Like = _DiaryShortsLike;
DiaryShorts.CommentBottomSheet = _DiaryShortsCommentBottomSheet;

export default DiaryShorts;
